import { EnvironmentValues } from '@llx/common';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import packageJson from '../package.json';
import './index.css';
import { config } from './config.ts';
import { initGA } from './modules/google-analytics/analytic/analytics.ts';

if (config.ENVIRONMENT !== EnvironmentValues.LOCAL) {
  Sentry.init({
    dsn: 'https://ded3db27c574a94263531a71bb0c4caf@o4509587308478464.ingest.de.sentry.io/4510165027061840',
    environment: config.ENVIRONMENT,
    release: packageJson.version,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: config.ENVIRONMENT === EnvironmentValues.PROD ? 0.5 : 1.0,
    replaysSessionSampleRate: config.ENVIRONMENT === EnvironmentValues.PROD ? 0.5 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error && typeof error === 'object' && 'code' in error) {
        if (error.code === 'refresh_token_not_found') return null;
      }
      if (event.message?.includes('React Router Future Flag Warning')) return null;
      if (event.message?.includes('fetchPriority')) return null;
      return event;
    },
  });
}

if (config.ENVIRONMENT === EnvironmentValues.PROD) {
  initGA();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
